import { render, staticRenderFns } from "./SubscriptionForm.Purchase.InovioPay.vue?vue&type=template&id=52dcf091&scoped=true&"
import script from "./SubscriptionForm.Purchase.InovioPay.vue?vue&type=script&lang=js&"
export * from "./SubscriptionForm.Purchase.InovioPay.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionForm.Purchase.InovioPay.vue?vue&type=style&index=0&id=52dcf091&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dcf091",
  null
  
)

export default component.exports